import { render, staticRenderFns } from "./roleauthorityset_test.vue?vue&type=template&id=5dca59d0&scoped=true&"
import script from "./roleauthorityset_test.vue?vue&type=script&lang=js&"
export * from "./roleauthorityset_test.vue?vue&type=script&lang=js&"
import style0 from "./roleauthorityset_test.vue?vue&type=style&index=0&id=5dca59d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca59d0",
  null
  
)

export default component.exports